import { render, staticRenderFns } from "./SmsTemplateAdd.vue?vue&type=template&id=fa048360&scoped=true&"
import script from "./SmsTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa048360",
  null
  
)

export default component.exports